export const TwoFAType = {
  unknown: 0,
  googleAuthenticator: 1,
  email: 2,
} as const

export type TwoFATypes = (typeof TwoFAType)[keyof typeof TwoFAType]
